export default __webpack_public_path__ + "static/limo-74ec52fd0cb2ac241c68645394e91a33.png";